import React from 'react';
import AdminNavbar from './Admin-navbar';

function ManageEmployee() {
  return (
    <>
    <div>
        <AdminNavbar />
    </div>
    <div>
      this is manage employee
    </div>
    </>
  );
}

export default ManageEmployee;
